import { AutoMap } from "@automapper/classes";
import { EIntegriteType } from "./enums/integrite-type";
import { PlageHoraire } from "./plage-horaire";
import { Pompe } from "./pompe";
import { ETetePrelevement } from "./enums/tete-prelevement";

export class Cassette {
    @AutoMap()
    Id?: number;
    @AutoMap()
    Reference!: string;
    @AutoMap()
    TypeTetePrelevement!: ETetePrelevement;
    @AutoMap()
    RefTetePrelevement!: string;
    @AutoMap()
    Integrite!: EIntegriteType;
    @AutoMap()
    DureePrelevement!: string;
    @AutoMap(() => [PlageHoraire])
    PlageHoraireList: PlageHoraire[] = [];
    @AutoMap()
    Pompe!: Pompe;

    public constructor(init?: Partial<Cassette>) {
        Object.assign(this, init);
    }
}